// @ts-nocheck
import "./ReviewItem.scss";

import { Component, h, render } from "preact";
import { useCallback, useState } from "preact/hooks";

import { DislikeIcon } from "../Icon/icons/fill/DislikeIcon";
import { DislikeOutlineIcon } from "../Icon/icons/outlined/DislikeOutlineIcon";
import ImagePopup from "../ImagePopup/ImagePopup";
import { LIMITATION_TYPE_ENUM } from "@/api/constants";
import { LikeIcon } from "../Icon/icons/fill/LikeIcon";
import { LikeOutlineIcon } from "../Icon/icons/outlined/LikeOutlineIcon";
import { StarIcon } from "../Icon/icons/fill/StarIcon";
import { StarOutlineIcon } from "../Icon/icons/outlined/StarOutlinedIcon";
import TextWithLinks from "@/utils/TextWithLinks";
import { createPortal } from "preact/compat";
import { getCustomText } from "@/utils/getCustomText";
import moment from "moment";
import { useLimitation } from "@/hooks/useLimitation";

moment.locale("ru");
const MAX_LENGTH = 300;

function ReviewItem({
  id,
  reviewer_name: name,
  text,
  value,
  created_at: createdAt,
  likes_count,
  dislikes_count,
  user_likes,
  user_dislikes,
  answer,
  images,
  onToggleLike,
  onToggleDislike,
}) {
  const [showAll, setShowAll] = useState(false);
  const [popupState, setPopupState] = useState({
    open: false,
    activeImage: 0,
  });
  const createdAtFormatedDate = moment(createdAt).format("DD.MM.YYYY");
  const isAllowedLikeDislike = useLimitation(
    LIMITATION_TYPE_ENUM.reviewLikeDislike
  );
  const isAllowedReviewsPhotos = useLimitation(
    LIMITATION_TYPE_ENUM.reivewsPhoto
  );
  const isAllowedShopAnswer = useLimitation(LIMITATION_TYPE_ENUM.shopAnswers);

  const handleOpenPopup = useCallback((activeImage) => {
    setPopupState({ open: true, activeImage });
  }, []);

  const handleClosePopup = useCallback(() => {
    setPopupState({ open: false, activeImage: 0 });
  }, []);

  const handleNextImage = useCallback(() => {
    setPopupState((prev) => ({
      ...prev,
      activeImage:
        prev.activeImage < images.length - 1 ? prev.activeImage + 1 : 0,
    }));
  }, [images.length]);

  const handlePrevImage = useCallback(() => {
    setPopupState((prev) => ({
      ...prev,
      activeImage:
        prev.activeImage > 0 ? prev.activeImage - 1 : images.length - 1,
    }));
  }, [images.length]);

  return (
    <div className="CCReviewItem t-text">
      {popupState.open &&
        createPortal(
          <ImagePopup
            images={images}
            activeImage={popupState.activeImage}
            isOpen={popupState.open}
            onClose={handleClosePopup}
            onNext={handleNextImage}
            onPrev={handlePrevImage}
          />,
          document.getElementById("CCModals")
        )}

      <div className="CCReviewItem__stars">
        <div
          className="CCReviewItem__stars_fill"
          style={{ "--cc-rating-width": `${(value / 5) * 100}%` }}
        >
          {new Array(5).fill(<StarIcon />)}
        </div>
        <div className="CCReviewItem__stars_outline">
          {new Array(5).fill(<StarOutlineIcon />)}
        </div>
      </div>

      <div className="CCReviewItem__params">
        <div class="CCReviewItem__params-name">{name}</div>
        <div class="CCReviewItem__params-date">{createdAtFormatedDate}</div>
      </div>

      <div className="CCReviewItem__text">
        {showAll ? text : text?.substr(0, MAX_LENGTH)}
        {text?.length > MAX_LENGTH && !showAll && "..."}
        {text?.length > MAX_LENGTH &&
          (showAll ? (
            <button
              className="CCReviewItem__show-more t-text"
              onClick={() => setShowAll(false)}
            >
              {getCustomText("reviewHideMore")}
            </button>
          ) : (
            <button
              className="CCReviewItem__show-more t-text"
              onClick={() => setShowAll(true)}
            >
              {getCustomText("reviewShowMore")}
            </button>
          ))}
      </div>

      {isAllowedReviewsPhotos && (
        <div className="CCReviewItem__images">
          {images.map((image, idx) => (
            <div
              className="CCReviewItem__images-item"
              onClick={() => handleOpenPopup(idx)}
            >
              <img src={image.url} />
            </div>
          ))}
        </div>
      )}

      {isAllowedLikeDislike ? (
        <div className="CCReviewItem__actions">
          <div className="CCReviewItem__actions-feedback">
            {getCustomText("reviewIsUseful")}
          </div>
          <button
            className="CCReviewItem__actions-btn"
            onClick={() => onToggleLike(id)}
          >
            {user_likes.includes(id) ? (
              <LikeIcon className="CCReviewItem__actions-icon" />
            ) : (
              <LikeOutlineIcon className="CCReviewItem__actions-icon" />
            )}
            <span className="CCReviewItem__actions-cnt t-text">
              {likes_count}
            </span>
          </button>
          <button
            className="CCReviewItem__actions-btn"
            onClick={() => onToggleDislike(id)}
          >
            {user_dislikes.includes(id) ? (
              <DislikeIcon className="CCReviewItem__actions-icon" />
            ) : (
              <DislikeOutlineIcon className="CCReviewItem__actions-icon" />
            )}
            <span className="CCReviewItem__actions-cnt t-text">
              {dislikes_count}
            </span>
          </button>
        </div>
      ) : null}

      {isAllowedShopAnswer && answer && (
        <div className="CCReviewItem__shop-answer">
          <div className="CCReviewItem__top">
            {answer.shop.logo && <img className="CCReviewItem__shop-logo" />}
            <div>
              <div className="CCReviewItem__shop-answer-title t-text">
                {answer.shop.name || getCustomText("shopAnswer")} {verifiedIcon}
              </div>
              <div className="CCReviewItem__answer-date">
                {moment(answer.created_at).format("DD MMMM, YYYY")}
              </div>
            </div>
          </div>
          <div className="CCReviewItem__shop-answer-text t-text">
            <TextWithLinks text={answer.text} />
          </div>
        </div>
      )}
    </div>
  );
}

const verifiedIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 6.66043C14 7.34185 13.0708 7.89937 12.885 8.58079C12.6991 9.2622 13.0708 10.2534 12.6991 10.7489C12.2655 11.3065 11.2124 11.2445 10.6549 11.6162C10.0973 11.9879 9.84956 13.041 9.16814 13.2888C8.54867 13.4746 7.74336 12.7932 7 12.7932C6.31858 12.7932 5.51327 13.4746 4.83186 13.2888C4.15044 13.1029 3.90266 12.0498 3.34513 11.6162C2.78761 11.1826 1.73451 11.3065 1.30088 10.7489C0.929204 10.1914 1.30088 9.20026 1.11504 8.58079C0.929204 7.96132 0 7.4038 0 6.66043C0 5.97902 0.929204 5.42149 1.11504 4.74008C1.30088 4.05866 0.929204 3.06751 1.30088 2.57194C1.79646 2.01441 2.84956 2.07636 3.40708 1.70468C3.9646 1.333 4.21239 0.279901 4.89381 0.0321133C5.51327 -0.153727 6.31858 0.527689 7.06195 0.527689C7.74336 0.527689 8.54867 -0.153727 9.23009 0.0321133C9.9115 0.217954 10.1593 1.27105 10.7168 1.70468C11.2743 2.13831 12.3274 2.01441 12.7611 2.57194C13.1327 3.12946 12.7611 4.12061 12.9469 4.74008C13.0708 5.42149 14 5.97902 14 6.66043Z"
      fill="#1FA1F0"
    />
    <path
      d="M4.46045 6.72231L6.13302 8.33293L9.5401 4.98779"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default ReviewItem;
